import Dashboard from '@/apps/account/provider/Dashboard.vue';
import { requireProvider } from '@/router/guards/authGuards';
import { checkSitterOnboarding } from '@/router/guards/completionGuards';
import combineGuards from '@/router/guards/helpers';

const providersDashboardRoutes = [
  {
    path: '/account/providers/dashboard',
    name: 'providers-dashboard',
    component: Dashboard,
    beforeEnter: combineGuards([requireProvider, checkSitterOnboarding]),
  },
];

export default providersDashboardRoutes;
